"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _lodash = require("lodash");
var _stores = require("@seedlang/stores");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ComprehendCardWrapper = function ComprehendCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "encouragement", _descriptor, _this);
      _initializerDefineProperty(_this, "expandConcept", _descriptor2, _this);
      _initializerDefineProperty(_this, "encouragementIndex", _descriptor3, _this);
      _this.onClickConcept = function () {
        _this.expandConcept = !_this.expandConcept;
      };
      _this.loadConcept = function () {
        var _this$props$card;
        if ((0, _utils.isPresent)(_this.props.card.tenseConceptId) && (!_stores.ConceptStore.hasShowData || _stores.ConceptStore.showData.id !== ((_this$props$card = _this.props.card) === null || _this$props$card === void 0 ? void 0 : _this$props$card.tenseConceptId))) {
          _stores.ConceptStore.getShow({
            ids: {
              conceptId: _this.props.card.tenseConceptId
            }
          });
        }
      };
      _this.onToggleEncouragement = function () {
        _this.encouragementIndex = _this.encouragementIndex === 0 ? 1 : 0;
      };
      _this.encouragement = (0, _lodash.shuffle)(_constants.Constants.ENCOURAGEMENTS[_this.props.card.word.languageId || 'EN'])[0];
      _this.loadConcept();
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "personalPronoun",
      get: function get() {
        var _this$props$card2;
        if (this.props.card.word.languageId === 'FR' && this.pronoun === 'singular_1p' && (_constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_FR.includes(this.props.correctAnswer[0]) || this.props.card.word.articleHasApostrophe)) {
          return 'J\'';
        }
        return _constants.Constants.PRONOUN_STRINGS[((_this$props$card2 = this.props.card) === null || _this$props$card2 === void 0 || (_this$props$card2 = _this$props$card2.word) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.languageId) || 'DE'][this.pronoun].split(',')[0];
      }
    }, {
      key: "pronoun",
      get: function get() {
        return this.props.pronoun || this.props.card.pronoun;
      }
    }, {
      key: "showVideo",
      get: function get() {
        return (0, _utils.isPresent)(this.videoClip);
      }
    }, {
      key: "videoClip",
      get: function get() {
        var _this$props$card$sent;
        return (_this$props$card$sent = this.props.card.sentence) === null || _this$props$card$sent === void 0 || (_this$props$card$sent = _this$props$card$sent.target) === null || _this$props$card$sent === void 0 ? void 0 : _this$props$card$sent.videoClip;
      }
    }, {
      key: "source",
      get: function get() {
        var _this$props$card$word;
        return (_this$props$card$word = this.props.card.word.vocabSourceListForUser(_state.AppUI.user)) === null || _this$props$card$word === void 0 ? void 0 : _this$props$card$word[0];
      }
    }, {
      key: "revealedText",
      get: function get() {
        if (this.props.userCard.correct) {
          return null;
        } else if ((0, _utils.isPresent)(this.props.cardState.textEntry)) {
          return "You answered: \"".concat(this.props.cardState.textEntry, "\"");
        } else if (this.props.clickedAnswer) {
          return "You answered: \"".concat(this.props.clickedAnswer, "\"");
        } else {
          return 'You didn\'t type anything!';
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          personalPronoun: this.personalPronoun,
          showVideo: this.showVideo,
          videoClip: this.videoClip,
          source: this.source,
          revealedText: this.revealedText,
          onToggleEncouragement: this.onToggleEncouragement,
          onClickConcept: this.onClickConcept,
          expandConcept: this.expandConcept
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "encouragement", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "expandConcept", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "encouragementIndex", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 0;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "personalPronoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "personalPronoun"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pronoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pronoun"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showVideo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "videoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "videoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "source", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "source"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revealedText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "revealedText"), _class2.prototype), _class2)) || _class;
};
ComprehendCardWrapper.displayName = 'ComprehendCardWrapper';
var _default = exports["default"] = ComprehendCardWrapper;